import apiClient from './apiClient';

export const listClienti = () => apiClient.get('/clienti/').then(r => r.data);

export const createClient = (payload) => apiClient.post('/clienti/', payload).then(r => r.data);

export const updateClient = (id, payload) => apiClient.put(`/clienti/${id}/`, payload).then(r => r.data);

export const deleteClient = (id) => apiClient.delete(`/clienti/${id}/`).then(r => r.data);

export const createBrand = (clientId, payload) => apiClient.post(`/clienti/${clientId}/brands/`, payload).then(r => r.data);

export const updateBrand = (brandId, payload) => apiClient.put(`/brands/${brandId}/`, payload).then(r => r.data);

export const deleteBrand = (brandId) => apiClient.delete(`/brands/${brandId}/`).then(r => r.data);
